import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';

import Loading from './components/Loading';
import Search from './components/Search';
import BookingError from './components/BookingError';
import Hotels from './components/Hotels';
import Assist from './components/Assist';
import Flights from './components/Flights';

import { useBookingColor, formatDate, getHref } from './helpers';

const PRODUCT_BY_SEARCH_TYPE = {
  0: 'flights',
  1: 'hotels',
  2: 'assist',
};

const MyBooking = ({ searchType }) => {
  const history = useHistory();

  const { name, business_types } = useSelector(
    store => store.pageConfiguration
  );

  const [bookingDetails, setBookingDetails] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [bookingStatus, setBookingStatus] = useState(undefined);
  const [bookingLabel, setBookingLabel] = useState(undefined);
  const [hasEntity, setHasEntity] = useState(undefined);

  const product = PRODUCT_BY_SEARCH_TYPE[searchType];

  const getBookingColor = useBookingColor(product);

  const commonProps = {
    searchType,
    bookingDetails,
    useBookingColor: getBookingColor,
    hasEntity,
    getHref,
    formatDate,
    history,
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return <Loading searchType={searchType} />;
  }

  if (hasError) {
    return <BookingError searchType={searchType} setHasError={setHasError} />;
  }

  // Estado inicial, muestra el buscador
  if (!bookingDetails && !hasError) {
    return (
      <Search
        searchType={searchType}
        setBookingDetails={setBookingDetails}
        setIsLoading={setIsLoading}
        setBookingStatus={setBookingStatus}
        setBookingLabel={setBookingLabel}
        setHasEntity={setHasEntity}
        setHasError={setHasError}
        history={history}
      />
    );
  }

  const componentMap = {
    1: (
      <Hotels
        {...commonProps}
        bookingStatus={bookingStatus}
        bookingLabel={bookingLabel}
        business_types={business_types}
        name={name}
      />
    ),
    2: <Assist {...commonProps} />,
    0: <Flights {...commonProps} />,
  };

  return componentMap[searchType];
};

export default MyBooking;
